import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromCurrentUser from './current-user.reducer';
import { CurrentUserEffects } from './current-user.effects';
import { CurrentUserFacade } from './current-user.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromCurrentUser.CURRENT_USER_FEATURE_KEY,
      fromCurrentUser.reducer
    ),
    EffectsModule.forFeature([CurrentUserEffects]),
  ],
  providers: [CurrentUserFacade],
})
export class CurrentUserStateModule {}
